import { createApp } from 'vue'
import App from './App.vue'
import store from '@/store'
import router from './router'
import 'animate.css'
import 'element-plus/dist/index.css'
import './style/index.scss'
import Icons from './config/icons'
import TimePicker from "@/components/Timepicker/index.vue";


import VMdPreview from '@kangc/v-md-editor/lib/preview';
import '@kangc/v-md-editor/lib/style/preview.css';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js'
import '@kangc/v-md-editor/lib/theme/style/vuepress.css'
import createMermaidPlugin from "@kangc/v-md-editor/lib/plugins/mermaid/cdn";
import createLineNumbertPlugin from "@kangc/v-md-editor/lib/plugins/line-number/index";
import createCopyCodePlugin from "@kangc/v-md-editor/lib/plugins/copy-code/index";
import "@kangc/v-md-editor/lib/plugins/copy-code/copy-code.css";
import createEmojiPlugin from "@kangc/v-md-editor/lib/plugins/emoji/index";
import "@kangc/v-md-editor/lib/plugins/emoji/emoji.css";
// import Prism from "prismjs";
// import "prismjs/components/prism-json";
import githubTheme from "@kangc/v-md-editor/lib/theme/github.js";
import "@kangc/v-md-editor/lib/theme/style/github.css";
// 引入所有语言包
import hljs from 'highlight.js';


VMdPreview.use(githubTheme, {
  Hljs: hljs,
});
// // markdown支持流程图
// VMdPreview.use(createMermaidPlugin())
// // markdown支持显示代码行数
VMdPreview.use(createLineNumbertPlugin())
// // markdown支持代码快速复制
VMdPreview.use(createCopyCodePlugin());
// // markdown支持emoji
VMdPreview.use(createEmojiPlugin());

const app = createApp(App)

const VMdPreviewPlugin = {
  install(app: any) {
    app.use(VMdPreview);
    // 如果 VMdPreview 是一个组件而不是插件，你可能需要这样注册
    // app.component('VMdPreview', VMdPreview);
  },
};

app.use(VMdPreviewPlugin);
app.component('TimePicker', TimePicker)

app
  .use(store)
  .use(router)
  .use(Icons)
  .mount('#app')
